import { useContext } from "react"
import PageRenderer from "./PageRenderer"
import { useAccessibility } from "../../context/AccessibilityContext"
import HeroRenderer from "./HeroRenderer"
import Career from "../../components/common/Career"
import { ReactComponent as WHEELCHAIR } from "../../assets/wheelchair.svg"
import { ReactComponent as PHONE } from "../../assets/telephone.svg"
import { ReactComponent as FOOD } from "../../assets/Food.svg"
import { ModalContext } from "../../context/ModalContext"
import AccessibilityModal from "../../components/common/AccessibilityModal"
import ContactModal from "../../components/common/ContactModal"
import NeutralPage from "./NeutralPage"
import FoodModal from "../../components/common/FoodModal"

type PageLoaderType = {
    data: any
}

export default function PageLoader(props: PageLoaderType) {
    // FE LOGIC
    const modalCon = useContext(ModalContext)
    const { getCursorPointerClass, getTextSpacingClass } = useAccessibility()

    return (
        <>
            <div className={`relative max-w-page mx-auto w-full  ${getTextSpacingClass()}`}>
                {/* BUTTONS */}
                <div className="fixed px-8 md:px-0 right-0 md:right-4 bottom-4 md:left-8 md:top-1/2 md:w-fit transform md:-translate-y-1/2 gap-2 md:gap-4 flex justify-right md:justify-center flex-row-reverse md:flex-col w-full z-40">
                    <button
                        className={`border-secondary bg-accent border-2 md:border-4 rounded-full p-3 sm:p-0 sm:rounded-xl sm:py-4 smm:px-1 hover:bg-secondary text-secondary hover:text-accent ${getCursorPointerClass()}`}
                        onClick={() => modalCon?.trigger(0)}>
                        <WHEELCHAIR className="w-8 h-8 sm:w-12 sm:h-12" />
                    </button>
                    <button
                        className={`border-secondary bg-accent border-2 md:border-4 rounded-full p-3 sm:p-0 sm:rounded-xl sm:py-4 sm:px-1 hover:bg-secondary text-secondary hover:text-accent ${getCursorPointerClass()}`}
                        onClick={() => modalCon?.trigger(1)}>
                        <PHONE className="w-8 h-8 sm:w-12 sm:h-12 " />
                    </button>
                    <button
                        className={`border-secondary bg-accent border-2 md:border-4 rounded-full p-3 sm:p-0 sm:rounded-xl sm:py-4 sm:px-1 hover:bg-secondary text-secondary hover:text-accent ${getCursorPointerClass()}`}
                        onClick={() => modalCon?.trigger(2)}>
                        <FOOD className="w-8 h-8 sm:w-12 sm:h-12 " />
                    </button>
                </div>

                {/* BODY */}
                <HeroRenderer heroes={props.data?.content?.heroVariants} />
                {props.data?.template === "start" && (
                    <PageRenderer modules={props.data?.content?.contentModuls} primaryColorCode={props.data.content.pageSettingColorText} />
                )}
                {props.data?.template === "karriere" && (
                    <Career {...props.data?.content} primaryColorCode={props.data.content.pageSettingColorPrimary} />
                )}
                {props.data?.template === "default" && <NeutralPage content={props.data?.content} />}
                <AccessibilityModal />
                <ContactModal contacts={props.data?.content?.pageSettingContactBlock} />
                <FoodModal />
            </div>
        </>
    )
}
